module.exports = __webpack_public_path__ + "img/4_09.f2d593f2.jpg";